import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

const HorizontalTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box className="overflow-y-auto" sx={{ width: "100%" }}>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable" // <--- ADICIONE ESTA LINHA
        scrollButtons="auto"  // <--- E ESTA LINHA
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.name}
            sx={{
              textTransform: "none",
              fontWeight: activeTab === index ? "bold" : "normal",
              color: activeTab === index ? "primary" : "inherit", // Use slate-500 equivalent
              "&.Mui-selected": {
                color: "primary", // Ensures the active tab matches slate-500
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default HorizontalTabs;
